export enum WishlistSortOptions {
  // Default order (most recently added to wishlist).
  UNSPECIFIED = 0,
  // Sorts the products by their absolute reduction amount
  HIGHEST_REDUCTION = 1,
  // Sorts the products based on their price in an descending order
  HIGHEST_PRICE = 2,
  // Sorts the products based on their price in an ascending order
  LOWEST_PRICE = 3,
  // Sorts the products based on the stock amount
  LOW_STOCK = 4,
}
